module.exports = __webpack_public_path__ + "dc1e6a617cfe18470ca5c66d091c6fab.png";